export const COUNTRIES = [
  { name: 'Nigeria', code: 'NG', dialCode: '+234' },
  { name: 'Ghana', code: 'GH', dialCode: '+233' },
  { name: 'Kenya', code: 'KE', dialCode: '+254' },
  { name: 'Uganda', code: 'UG', dialCode: '+256' },
  { name: "Côte d'Ivoire", code: 'CI', dialCode: '+225' },
  { name: 'Senegal', code: 'SN', dialCode: '+221' },
  { name: 'South Africa', code: 'ZA', dialCode: '+27' },
  { name: 'Morocco', code: 'MA', dialCode: '+212' },
  { name: 'Egypt', code: 'EG', dialCode: '+20' },
  { name: 'USA', code: 'US', dialCode: '+1' },
] as const;

export type CountryCode = (typeof COUNTRIES)[number]['code'];

const US_ALIASES = new Set(['UNITED STATES', 'UNITED STATES OF AMERICA', 'U.S.A.', 'U.S.']);

export function countryNameFromCode(code?: string) {
  if (!code) return '';
  return COUNTRIES.find((country) => country.code.toUpperCase() === code.toUpperCase())?.name ?? code;
}

export function countryCodeFromName(nameOrCode?: string) {
  if (!nameOrCode) return '';
  const query = nameOrCode.toUpperCase();
  if (query === 'IVORY COAST' || query === "COTE D'IVOIRE") return 'CI';
  if (US_ALIASES.has(query)) return 'US';
  return COUNTRIES.find((country) => country.name.toUpperCase() === query || country.code.toUpperCase() === query)?.code ?? nameOrCode;
}

export function dialCodeFromCountry(nameOrCode?: string) {
  if (!nameOrCode) return '';
  const query = nameOrCode.toUpperCase();
  if (query === 'IVORY COAST' || query === "COTE D'IVOIRE") return '+225';
  if (US_ALIASES.has(query)) return '+1';
  return COUNTRIES.find((country) => country.name.toUpperCase() === query || country.code.toUpperCase() === query)?.dialCode ?? '';
}

